import { SBTranslate } from "i18n";
import { SBBox, SBIcon, SBIconButton, SBMenu, SBMenuItem, SBTypography } from "modules/Commons";
import { RecommendationSecurityLimitFrequency } from "modules/SecurityLimit/RecommendationSecurityLimitFrequency";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./style";

const ConfigRecommendationSecurityLimitFrequency = ({ value, onUpdate }: ConfigRecommendationSecurityLimitFrequencyProps) => {
	const menuRef = useRef();
	const { t } = useTranslation();
	const classes = useStyles();

	const [recommendationSecurityLimitFrequency, setRecommendationSecurityLimitFrequency] = useState<RecommendationSecurityLimitFrequency | null>(value ?? null);
	const [adornmentText, setAdornmentText] = useState<string>("day_other");

	const securityLimitFrequencies = [
		{ text: SBTranslate("day_other"), value: RecommendationSecurityLimitFrequency.daily },
		{ text: SBTranslate("month_other"), value: RecommendationSecurityLimitFrequency.monthly },
	]

	const updateEmergencialCoverageMode = (value: number) => {
		setRecommendationSecurityLimitFrequency(value);
	}

	useEffect(() => {
		if (recommendationSecurityLimitFrequency === null || recommendationSecurityLimitFrequency === 1) {
			setAdornmentText("day_other");
		} else {
			setAdornmentText("month_other");
		}
		onUpdate(recommendationSecurityLimitFrequency);
	}, [recommendationSecurityLimitFrequency]);

	return (
		<SBBox display="flex" alignItems="center">
			{t(adornmentText)}
			<>
				<SBMenu
					ref={menuRef}
					canOpen
					action={
						<SBBox className={classes.configAdornmentSelect}>
							<SBIconButton>
								<SBIcon
									icon="select"
									size={20}
								/>
							</SBIconButton>
						</SBBox>
					}
					content={
						<SBBox>
							{securityLimitFrequencies.map((item: any) => (
								<SBMenuItem
									key={item.value}
									value={item.value}
									style={{ zIndex: 100 }}
									onClick={() => {
										updateEmergencialCoverageMode(item.value);
										(menuRef.current as any).close()
									}
									}
								>
									<SBBox display="flex">
										<SBTypography noWrap style={{ maxWidth: 350 }}>
											{item.text}
										</SBTypography>
									</SBBox>
								</SBMenuItem>
							))}
						</SBBox>
					}
				/>
			</>
		</SBBox>
	);
};


interface ConfigRecommendationSecurityLimitFrequencyProps {
	value: RecommendationSecurityLimitFrequency;
	onUpdate: (v: RecommendationSecurityLimitFrequency | null) => void;
}
export default ConfigRecommendationSecurityLimitFrequency;
